import { Controller } from '@hotwired/stimulus';

const STORAGE_KEY = 'flow-theme';

export default class extends Controller {
  static targets = ['label', 'lightIcon', 'darkIcon'];

  connect() {
    this.#render(this.#current);
  }

  toggle() {
    const next = this.#current === 'dark' ? 'light' : 'dark';

    localStorage.setItem(STORAGE_KEY, next);
    document.documentElement.setAttribute('data-theme', next);
    this.#render(next);
  }

  get #current() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  #render(theme) {
    const dark = theme === 'dark';

    this.lightIconTarget.classList.toggle('hidden', !dark);
    this.darkIconTarget.classList.toggle('hidden', dark);

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.labelTarget.dataset[dark ? 'light' : 'dark'];
    }

    this.element.title = this.labelTarget?.textContent ?? '';
  }
}
